import { useEffect } from 'react';
import { Link, useRouteError } from 'react-router-dom';

// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project imports
import { APP_DEFAULT_PATH } from 'config';
import { ehErroDeChunk, reloadParaChunkObsoleto } from 'utils/chunkReload';

// assets
import error500 from 'assets/images/maintenance/Error500.png';

// ==============================|| ERROR 500 - MAIN ||============================== //

export default function Error500() {
  const error = useRouteError();
  const downSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  // Chunk lazy obsoleto após deploy: recarrega para pegar o build novo em vez de mostrar "500".
  const chunkObsoleto = ehErroDeChunk(error);
  useEffect(() => {
    if (chunkObsoleto) reloadParaChunkObsoleto();
  }, [chunkObsoleto]);

  if (error) {
    console.error('Application Error:', error);
  }

  if (chunkObsoleto) {
    return (
      <Grid container sx={{ minHeight: '100vh', alignItems: 'center', justifyContent: 'center' }}>
        <Stack spacing={2} sx={{ alignItems: 'center' }}>
          <CircularProgress />
          <Typography color="text.secondary" variant="body2">Atualizando para a nova versão…</Typography>
        </Stack>
      </Grid>
    );
  }

  return (
    <Grid container sx={{ minHeight: '100vh', alignItems: 'center', justifyContent: 'center' }}>
      <Grid size={12}>
        <Stack sx={{ alignItems: 'center', justifyContent: 'center' }}>
          <Box sx={{ width: { xs: 350, sm: 396 }, my: 2 }}>
            <CardMedia component="img" src={error500} alt="Rocky" />
          </Box>
          <Typography align="center" variant={downSM ? 'h2' : 'h1'}>
            Erro interno no servidor
          </Typography>
          <Typography color="text.secondary" variant="body2" align="center" sx={{ width: { xs: '73%', sm: '70%' }, mt: 1 }}>
            Ocorreu um erro inesperado (500). Já estamos trabalhando para resolver. Tente novamente em alguns minutos.
          </Typography>
          <Button component={Link} to={APP_DEFAULT_PATH} variant="contained" sx={{ textTransform: 'none', mt: 4 }}>
            Voltar ao início
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
}
